import React from 'react';

/**
 * SkipToContent Component
 * Accessibility feature for keyboard navigation
 * Allows users to skip navigation and go directly to main content
 */
const SkipToContent = ({ contentId = 'main-content' }) => {
  return (
    <a 
      href={`#${contentId}`}
      className="skip-to-main"
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
  );
};

export default SkipToContent;
